import { ButtonStatus, RelationType } from "./Const";
import { ButtonPageAlternatives } from "./GButton";
import { GLabel } from "./GLabel";
import { UIConfig2 } from "./UIConfig";
import { Input } from "../display/Input";
import { GRoot } from "./GRoot";
import { UIEvent } from "./UIEvent";
import { Event } from "../events/Event";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { NodeFlags } from "../Const";
export class GComboBox extends GLabel {
    constructor() {
        super();
        this.popupDirection = 0;
        this.visibleItemCount = 0;
        this._itemsUpdated = true;
        this._selectedIndex = -1;
        this._items = [];
        this._icons = [];
        this._values = [];
        this.on(Event.ROLL_OVER, this, this._rollover);
        this.on(Event.ROLL_OUT, this, this._rollout);
        this.on(Event.MOUSE_DOWN, this, this._mousedown);
        this.on(Event.MOUSE_UP, this, this._mouseup);
    }
    get items() {
        return this._items;
    }
    set items(value) {
        let arr = this._items;
        arr.length = 0;
        if (value)
            arr.push(...value);
        this._itemsUpdated = true;
        if (SerializeUtil.isDeserializing) {
            if (arr.length > 0)
                this._selectedIndex = 0;
            return;
        }
        if (arr.length > 0) {
            if (this._selectedIndex >= arr.length)
                this._selectedIndex = arr.length - 1;
            else if (this._selectedIndex == -1)
                this._selectedIndex = 0;
            this.title = arr[this._selectedIndex];
            if (this._selectedIndex < this._icons.length)
                this.icon = this._icons[this._selectedIndex];
        }
        else {
            this.title = "";
            if (this._icons)
                this.icon = null;
            this._selectedIndex = -1;
        }
    }
    get icons() {
        return this._icons;
    }
    set icons(value) {
        let arr = this._icons;
        arr.length = 0;
        if (value)
            arr.push(...value);
        this._itemsUpdated = true;
        if (SerializeUtil.isDeserializing)
            return;
        if (this._selectedIndex != -1 && this._selectedIndex < arr.length)
            this.icon = arr[this._selectedIndex];
    }
    get values() {
        return this._values;
    }
    set values(value) {
        this._values.length = 0;
        if (value)
            this._values.push(...value);
        this._itemsUpdated = true;
    }
    get selectedIndex() {
        return this._selectedIndex;
    }
    set selectedIndex(val) {
        var _a;
        if (this._selectedIndex === val && !this._itemsUpdated)
            return;
        this._selectedIndex = val;
        if (val >= 0 && val < this._items.length) {
            this.title = this._items[val];
            if (val < this._icons.length)
                this.icon = this._icons[val];
        }
        else {
            this.title = "";
            if (this._icons)
                this.icon = "";
        }
        let cc = (_a = this._selectedController) === null || _a === void 0 ? void 0 : _a.inst;
        if (cc != null && val >= 0 && val < cc.numPages && !cc.changing)
            this._selectedController.selectedIndex = val;
    }
    get value() {
        return this._values[this._selectedIndex];
    }
    set value(val) {
        let index = this._values.indexOf(val);
        if (index == -1 && val == null)
            index = this._values.indexOf("");
        this.selectedIndex = index;
    }
    get dropdownRes() {
        return this._dropdownRes;
    }
    set dropdownRes(value) {
        this._dropdownRes = value;
        if (!this._getBit(NodeFlags.EDITING_NODE))
            this.createDropdown();
    }
    get dropdown() {
        return this._dropdown;
    }
    get selectedController() {
        return this._selectedController;
    }
    set selectedController(value) {
        if (this._selectedController)
            this._selectedController.release();
        this._selectedController = value;
        if (value) {
            value.validate();
            value.onChanged = this.selectChanged.bind(this);
            this.selectChanged();
        }
    }
    destroy() {
        if (this._dropdown) {
            this._dropdown.destroy();
            this._dropdown = null;
        }
        if (this._selectedController)
            this._selectedController.release();
        super.destroy();
    }
    updateList() {
        if (!this._dropdown.stage)
            return;
        this._updateDropDown();
        this._list.layout.refresh();
        GRoot.inst.popupMgr.validatePopupPosition(this._dropdown, this, this.popupDirection);
    }
    createDropdown() {
        if (this._dropdown) {
            this._dropdown.destroy();
            this._dropdown = null;
            this._list = null;
        }
        if (this._dropdownRes) {
            this._dropdown = this._dropdownRes.create();
            this._list = this._dropdown.getChild("list");
            if (this._list == null) {
                console.warn(this._dropdownRes.url + ": should container a list component named list.");
                return;
            }
            this._list.on(UIEvent.ClickItem, this, this._clickItem);
            this._list.addRelation(this._dropdown, RelationType.Width);
            this._list.removeRelation(this._dropdown, RelationType.Height);
            this._dropdown.addRelation(this._list, RelationType.Height);
            this._dropdown.removeRelation(this._list, RelationType.Width);
            this._dropdown.on(Event.UNDISPLAY, this, this._popupWinClosed);
        }
    }
    _controllersChanged() {
        super._controllersChanged();
        let c = this.getController("button");
        if (this._buttonController != c) {
            this._buttonController = c;
            if (this._buttonController.numPages > 0)
                this.setCurrentState();
        }
    }
    selectChanged() {
        this.selectedIndex = this._selectedController.selectedIndex;
    }
    setState(page) {
        if (this._buttonController) {
            if (page >= this._buttonController.numPages) {
                page = ButtonPageAlternatives[page];
                if (page == null)
                    return;
            }
            this._buttonController.selectedIndex = page;
        }
    }
    setCurrentState() {
        let p = (this._dropdown && this._dropdown.displayedInStage) ? ButtonStatus.Down : (this._over ? ButtonStatus.Over : ButtonStatus.Up);
        this.setState(this.grayed ? ButtonStatus.Disabled : p);
    }
    showDropdown() {
        if (!this._dropdown) {
            this.setState(ButtonStatus.Down);
            return;
        }
        if (GRoot.inst.popupMgr.isPopupJustClosed(this._dropdown))
            return;
        this.event(UIEvent.Popup);
        if (this._itemsUpdated)
            this._updateDropDown();
        this._list.selection.index = -1;
        this._dropdown.width = this.width;
        this._list.layout.refresh();
        GRoot.inst.popupMgr.showPopup(this._dropdown, this, this.popupDirection);
        this.setState(ButtonStatus.Down);
    }
    _updateDropDown() {
        this._itemsUpdated = false;
        this._list.removeChildrenToPool();
        let cnt = this._items.length;
        for (let i = 0; i < cnt; i++) {
            let item = this._list.addItemFromPool();
            item.name = i < this._values.length ? this._values[i] : "";
            item.text = this._items[i];
            item.icon = i < this._icons.length ? this._icons[i] : "";
        }
        this._list.resizeToFit(this.visibleItemCount > 0 ? this.visibleItemCount : UIConfig2.defaultComboBoxVisibleItemCount);
    }
    _popupWinClosed() {
        this.setCurrentState();
    }
    _clickItem(item) {
        GRoot.inst.popupMgr.hidePopup(this._dropdown);
        this._selectedIndex = -1;
        this.selectedIndex = this._list.getChildIndex(item);
        this.event(Event.CHANGED);
    }
    _rollover() {
        this._over = true;
        if (this._down || this._dropdown && this._dropdown.parent)
            return;
        this.setCurrentState();
    }
    _rollout() {
        this._over = false;
        if (this._down || this._dropdown && this._dropdown.parent)
            return;
        this.setCurrentState();
    }
    _mousedown(evt) {
        if (evt.target instanceof Input)
            return;
        this._down = true;
        this.showDropdown();
    }
    _mouseup() {
        if (this._down) {
            this._down = false;
            this.setCurrentState();
        }
    }
}
